import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo } from 'react';
import { Button, Label, Modal } from '@cancercentrum/rcc-bootstrap';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { useI18n } from '../../i18n';
import { useDataActions } from '../../hooks/useDataActions';
import { useRowModel } from '../../hooks/useRowModel';
import { ErrorList } from './ErrorList';
const ReviewModal = (props)=>{
    const { validationPredicate, showModal, closeModalFunc, modalHeader } = props;
    const dataActions = useDataActions();
    useEffect(()=>{
        if (showModal) {
            dataActions.updateRow((r)=>r.markInvalidEntriesAsDirty());
        }
    }, [
        dataActions,
        showModal
    ]);
    const { t } = useI18n();
    const row = useRowModel({
        path: [],
        detachedId: null
    });
    const errors = useMemo(()=>row.getErrors({
            includePristine: true,
            validationPredicate: validationPredicate
        }), [
        row,
        validationPredicate
    ]);
    const errorsCount = errors.filter((x)=>x.$errors.some((y)=>y.isError) || x.$errors.some((y)=>y.name && y.isFatal)).length;
    const warningsCount = errors.filter((x)=>x.$errors.some((y)=>y.isWarning) || x.$errors.some((y)=>y.name && y.isFatal === false)).length;
    const hasErrors = errorsCount !== 0;
    const hasWarnings = warningsCount !== 0;
    const validationSuccess = !hasErrors && !hasWarnings;
    return /*#__PURE__*/ _jsx("div", {
        children: /*#__PURE__*/ _jsxs(Modal, {
            show: showModal,
            onHide: closeModalFunc,
            bsSize: "lg",
            children: [
                /*#__PURE__*/ _jsx(Modal.Header, {
                    closeButton: true,
                    children: /*#__PURE__*/ _jsx(Modal.Title, {
                        children: modalHeader ?? t('component.reviewform.header')
                    })
                }),
                /*#__PURE__*/ _jsxs(Modal.Body, {
                    children: [
                        validationSuccess && /*#__PURE__*/ _jsx("p", {
                            children: /*#__PURE__*/ _jsx(Label, {
                                className: "review-label",
                                bsStyle: "success",
                                children: t('component.reviewform.success')
                            })
                        }),
                        !validationSuccess && /*#__PURE__*/ _jsxs("p", {
                            children: [
                                hasErrors && /*#__PURE__*/ _jsxs(Label, {
                                    className: "review-label me-2",
                                    bsStyle: "danger",
                                    children: [
                                        t('component.reviewform.errorsCount'),
                                        ": ",
                                        errorsCount
                                    ]
                                }),
                                !hasErrors && /*#__PURE__*/ _jsx(Label, {
                                    className: "review-label me-2",
                                    bsStyle: "success",
                                    children: t('component.reviewform.errorsSuccess')
                                }),
                                hasWarnings && /*#__PURE__*/ _jsxs(Label, {
                                    className: "review-label",
                                    bsStyle: "warning",
                                    children: [
                                        t('component.reviewform.warningsCount'),
                                        ": ",
                                        warningsCount
                                    ]
                                }),
                                !hasWarnings && /*#__PURE__*/ _jsx(Label, {
                                    className: "review-label",
                                    bsStyle: "success",
                                    children: t('component.reviewform.warningsSuccess')
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(ErrorList, {
                            errors: errors
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(Modal.Footer, {
                    children: /*#__PURE__*/ _jsx(Button, {
                        onClick: closeModalFunc,
                        bsStyle: "default-2",
                        icon: faTimes,
                        children: t('button.close')
                    })
                })
            ]
        })
    });
};
export default ReviewModal;
